import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function FCadenas() {
    const [cadenas, setCadenas] = useState([]);
    const [cadenasFiltradas, setCadenasFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idCadena: '',
        nomCadena: ''
    });
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/cadenas';

    useEffect(() => {
        cargarCadenas();
    }, []);

    useEffect(() => {
        filtrarCadenas();
    }, [busqueda, cadenas]);

    const cargarCadenas = async () => {
        try {
            const response = await axios.get(API_URL);
            setCadenas(response.data);
            setCadenasFiltradas(response.data);
        } catch (error) {
            console.error('Error al cargar cadenas:', error);
            alert('Error al cargar las cadenas');
        }
    };

    const filtrarCadenas = () => {
        if (!busqueda) {
            setCadenasFiltradas(cadenas);
            setPaginaActual(1);
            return;
        }

        const filtrados = cadenas.filter(cadena =>
            cadena.idCadena?.toString().includes(busqueda) ||
            cadena.nomCadena?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setCadenasFiltradas(filtrados);
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idCadena: '',
            nomCadena: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (cadena) => {
        setFormulario({
            idCadena: cadena.idCadena,
            nomCadena: cadena.nomCadena
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idCadena: '',
            nomCadena: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomCadena.trim()) {
            alert('El nombre de la cadena es requerido');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idCadena}`, formulario);
                alert('Cadena actualizada exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('Cadena creada exitosamente');
            }
            cargarCadenas();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar la cadena');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar esta cadena?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Cadena eliminada exitosamente');
                cargarCadenas();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar la cadena');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = cadenasFiltradas.map(cadena => ({
            'ID': cadena.idCadena,
            'Nombre': cadena.nomCadena
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Cadenas');
        XLSX.writeFile(workbook, 'cadenas.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const cadenasActuales = cadenasFiltradas.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(cadenasFiltradas.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Cadenas</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nueva Cadena
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre de la Cadena</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cadenasActuales.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay cadenas para mostrar</td>
                            </tr>
                        ) : (
                            cadenasActuales.map(cadena => (
                                <tr key={cadena.idCadena}>
                                    <td>{cadena.idCadena}</td>
                                    <td>{cadena.nomCadena}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(cadena)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(cadena.idCadena)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, cadenasFiltradas.length)} de {cadenasFiltradas.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Cadena' : 'Nueva Cadena'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre de la Cadena *</label>
                                <input
                                    type="text"
                                    value={formulario.nomCadena}
                                    onChange={(e) => setFormulario({ ...formulario, nomCadena: e.target.value })}
                                    required
                                    maxLength={60}
                                    placeholder="Ingrese el nombre de la cadena"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FCadenas;
